<div class="gx-shell">
  <!-- ══════════════════════════════════════════════
       WIDGET GRID
  ══════════════════════════════════════════════ -->
  <main class="gx-grid row g-0">
    <!-- Team Activity -->
    <div class="col-12 col-lg-6 gx-cell">
      <div class="gx-card gx-card--team h-100">
        <div class="gx-card__header">
          <div class="gx-card__accent-bar"></div>
          <div class="gx-card__header-inner d-flex align-items-center gap-2">
            <div class="gx-card__icon-wrap">
              <mat-icon class="gx-card__icon">groups</mat-icon>
            </div>
            <div>
              <div class="gx-card__title">Team Activity</div>
            </div>
          </div>
        </div>
        <div class="gx-card__body">
          <app-team-activity [teamId]="me?.teamId"></app-team-activity>
        </div>
      </div>
    </div>

    <!-- Battles -->
    <div class="col-12 col-lg-6 gx-cell">
      <div class="gx-card gx-card--battle h-100">
        <div class="gx-card__header">
          <div class="gx-card__accent-bar"></div>
          <div class="gx-card__header-inner d-flex align-items-center gap-2">
            <div class="gx-card__icon-wrap">
              <mat-icon class="gx-card__icon">sports_kabaddi</mat-icon>
            </div>
            <div>
              <div class="gx-card__title">Battles</div>
            </div>
          </div>
        </div>
        <div class="gx-card__body">
          <app-challenges-list
            (onAddChallengeWager)="addChallengeWager()"
            [autoRefresh]="autoRefresh"
          ></app-challenges-list>
        </div>
      </div>
    </div>

    <!-- Wagers -->
    <div class="col-12 col-lg-6 gx-cell">
      <div class="gx-card gx-card--wager h-100">
        <div class="gx-card__header">
          <div class="gx-card__accent-bar"></div>
          <div class="gx-card__header-inner d-flex align-items-center gap-2">
            <div class="gx-card__icon-wrap">
              <mat-icon class="gx-card__icon">how_to_vote</mat-icon>
            </div>
            <div>
              <div class="gx-card__title">Wagers</div>
            </div>
          </div>
        </div>
        <div class="gx-card__body">
          <app-challenge-wagers-list [showChallenges]="false" [autoRefresh]="autoRefresh"></app-challenge-wagers-list>
        </div>
      </div>
    </div>

    <!-- Stats -->
    <div class="col-12 col-lg-6 gx-cell">
      <div class="gx-card gx-card--stats h-100">
        <div class="gx-card__header">
          <div class="gx-card__accent-bar"></div>
          <div class="gx-card__header-inner d-flex align-items-center gap-2">
            <div class="gx-card__icon-wrap">
              <mat-icon class="gx-card__icon">bar_chart</mat-icon>
            </div>
            <div>
              <div class="gx-card__title">Conversation Stats</div>
            </div>
          </div>
        </div>
        <div class="gx-card__body">
          <app-conversation-statistics-widget [userId]="me?.cognitoId"></app-conversation-statistics-widget>
        </div>
      </div>
    </div>
  </main>
</div>
